(() => {
  if (customElements.get('kbc-opt-in')) return;
  const key = 'koppenbergcross_2026_opt_in';
  let desired;
  let confirmed;
  let saving = null;
  let error = false;
  const widgets = () => [...document.querySelectorAll('kbc-opt-in')];
  function paint(message = '') {
    for (const widget of widgets()) {
      const toggle = widget.querySelector('[data-kbc-toggle]');
      if (!toggle) continue;
      toggle.checked = Boolean(desired);
      toggle.disabled = false;
      toggle.setAttribute('aria-invalid', String(error));
      widget.querySelector('[data-kbc-value]').value = desired ? 'true' : '';
      widget.querySelector('[role="status"]').textContent = message;
    }
  }
  function save(cartUrl, force = false) {
    if (saving) return saving;
    if (!force && confirmed === desired && !error) return Promise.resolve();
    error = false;
    paint('Je keuze wordt opgeslagen…');
    saving = (async () => {
      do {
        const value = desired;
        const response = await fetch(`${cartUrl}/update.js`, {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: { [key]: value ? 'true' : '' } }),
          signal: AbortSignal.timeout(15000)
        });
        if (!response.ok) throw new Error('Cart attribute save failed');
        const cart = await response.json();
        if ((cart.attributes?.[key] === 'true') !== value) throw new Error('Cart attribute not confirmed');
        confirmed = value;
      } while (confirmed !== desired);
      paint(desired ? 'Je deelnamekeuze is opgeslagen.' : '');
    })().catch((reason) => {
      error = true;
      paint('Je keuze kon niet worden opgeslagen. Probeer opnieuw door je keuze te wijzigen of op afrekenen te klikken.');
      throw reason;
    }).finally(() => { saving = null; });
    return saving;
  }
  class KbcOptIn extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const toggle = this.querySelector('[data-kbc-toggle]');
      if (desired === undefined) desired = confirmed = toggle.checked;
      paint();
      this.addEventListener('change', (event) => {
        if (event.target !== toggle) return;
        // Dawn cart-items treats every bubbled change as a quantity edit.
        event.stopPropagation();
        desired = toggle.checked;
        paint();
        save(this.dataset.cartUrl).catch(() => {});
      });
    }
  }
  customElements.define('kbc-opt-in', KbcOptIn);
  const resuming = new WeakSet();
  const submitting = new WeakSet();
  document.addEventListener('submit', async (event) => {
    const form = event.target;
    const widget = widgets().find(item => item.dataset.form === form.id);
    if (!widget || resuming.has(form)) return;
    const submitter = event.submitter;
    if (submitter && submitter.name !== 'checkout') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (submitting.has(form)) return;
    submitting.add(form);
    try {
      // Reconfirm at checkout, including unchecked state, after cart re-renders or other tabs.
      await save(widget.dataset.cartUrl, true);
      resuming.add(form);
      try { form.requestSubmit(submitter || undefined); }
      finally { resuming.delete(form); }
    } catch (_) {
      widget.querySelector('[data-kbc-toggle]').focus();
    } finally {
      submitting.delete(form);
    }
  }, true);
  window.addEventListener('pageshow', (event) => {
    if (!event.persisted || !widgets().length) return;
    // A back/forward cache return can follow a completed order. Reload server cart state.
    window.location.reload();
  });
})();
